// Utilidades genéricas: RNG con semilla (para partidas deterministas), IDs, math.

/** Generador congruente con semilla (mulberry32). Determinista → apto para multijugador. */
export function createRNG(seed = 123456789) {
  let a = seed >>> 0;
  return function next() {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Baraja un array in-place usando un RNG dado (Fisher-Yates). */
export function shuffleInPlace(arr, rng = Math.random) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

let _idCounter = 0;
/** ID incremental único dentro de la sesión (no criptográfico). */
export function uid(prefix = 'id') {
  _idCounter += 1;
  return `${prefix}-${_idCounter}`;
}

export function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

/** Semilla derivada de una fecha (para el puzzle diario, sin Date.now aleatorio). */
export function seedFromDateString(dateStr) {
  let h = 2166136261;
  for (let i = 0; i < dateStr.length; i++) {
    h ^= dateStr.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Clona profundamente estructuras JSON-serializables. */
export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/** Formatea segundos como m:ss. */
export function formatTime(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}
